module.exports = __webpack_public_path__ + "f7a21c31a04078e0b084fb5db0abfcac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ML.svg
// module id = o42T
// module chunks = 0